import React, { FunctionComponent } from 'react';
import { TLazyIconKey } from '../../utilities/iconLoader/FontAwesomeIcon';
import { RouteComponentProps } from '@reach/router';
import { FormikErrors } from 'formik';
import { PayRentTypes } from './PayRentTypes';
import { UpdateContactDetailsTypes } from './UpdateContactDetailsTypes';
import { HeaderTypes } from '../sitewide';

export namespace AccountPanelTypes {
  export type TNewCardSection = {
    callBackHandler: TCallBackHandler;
    billingDetailsConfig?: TBillingDetailsInfoConfig;
    payment_method: any;
    cardProcessorIds: any;
    configs?: any;
    facilityId: string;
    tenantIdFromCreationAPI?: string;
    contextData?: any;
    individualUnitData?: any;
    isSurchargeOrDiscountAvailable?: boolean;
    parentChargeDetailsUpdater?: any;
    tfwPaymentConfig?: any;
    preferred_payment_method_id?: string;
    customAmount: string;
    setCustomAmount: (event: any) => void;
    customAmountError?: any;
    amountResolution: string;
    setAmountResolution: (value: string) => void;
    paymentType: string;
    setPaymentType?: (value: string) => void;
    public_key: string;
    tenantToken: string | undefined;
    isLoadingPaymentInfo?: boolean;
  };
  export type TCardDetailsFormInitialValues = {
    cardNumber: string;
    expiryDate: string;
    cvv: string;
    holderName: string;
    address: string;
    city: string;
    postalCode: string;
    amount: string;
    saveCardDetails: boolean;
    autoPay: boolean;
  };
  export type TCardTypeIcon = {
    cardNumber: string;
  };
  export interface TLayout {
    children: JSX.Element | JSX.Element[];
    ledgerList: any;
    currentLedgerId?: string;
    locationName: string;
    name: TName;
    email_address: TEmail;
    logOutHandler: () => void;
    bodyHeight: number;
  }
  export type TUserDetailsSection = {
    name: TName;
    email_address: TEmail;
    siteType: string;
    currentLocation: HeaderTypes.TLocationDetails;
  };
  export type TUserDetailsDropDown = {
    name: TName;
    showUserInfoSection: boolean;
  };
  export type TLedgerSwitchControlSection = {
    state: boolean;
    stateHandler: (e: any) => void;
  };
  export type TLogOutModal = {
    bodyHeight: number;
    logOutHandler: () => void;
    hideModal: () => void;
  };
  export type TLedgerSectionLogOutHandler = {
    logOutHandler: () => void;
  };
  export type TName = {
    first_name: string;
    last_name: string;
  };
  export type TEmail = {
    email_address: string;
    is_email_enabled: boolean;
  };
  export type TDropdownLedgerList = {
    id: string;
    label: string;
  };
  export type TCardTypes = {
    name: string;
    regex: any;
    icon: string;
  };
  export type TIconHelper = {
    icon: TLazyIconKey;
    size?: string;
    color?: string;
  };
  export type TSideNavBar = {
    sideBarConfig: TSideBarItem[];
    currRef: any;
    locationName: string;
    closeSideNavBar: () => void;
    logOutHandler: () => void;
    logOutLinkClickHandler: () => void;
    bodyHeight: number;
  };
  export type TDropDown = {
    dropDownList: any;
    defaultValue?: string;
    updateSelectedValue: (e: any) => void;
    label: string;
  };
  export type TSmallScreenFooter = {
    goBack: any;
  };
  export type TSideBarItem = {
    url: string;
    linkName: string;
    icon: TLazyIconKey;
    RenderAs: React.ComponentType<any>;
  };
  export type TExistingInitialValues = {
    amount: string;
    autoPay: boolean;
  };
  export type TCallBackHandler = (
    formRequestBody: any,
    formData?: any
  ) => Promise<any>;
  export type THomePage = (props: any) => JSX.Element;
  export type TBillingDetailsInfoConfig = {
    current_balance_due?: string | number;
    estimated_new_charges?: any;
    next_billing_data?: string;
    new_balance?: any;
    chargeType?: string;
    charge_amount?: string;
  };
  export type TBillingDetailsProp = TBillingDetailsInfoConfig & {
    isPrepaymentAllowed?: boolean;
    isPartialPaymentAllowed?: boolean;
    parentChargeDetailsUpdater?: (newValues: object) => void;
    preferred_payment_method_id?: string;
    facility_id: string;
    customAmount: any;
    setCustomAmount: (event: any) => void;
    customAmountError: any;
    amountResolution: string;
    setAmountResolution: (value: string) => void;
    isCardPaymentTypeChanges?: boolean;
    tenantToken: string | undefined;
  };

  export type TAccountPanelPage = {
    Id?: string;
    children: JSX.Element | JSX.Element[];
  };
  export type TPrivateRoutes = RouteComponentProps & {
    component: FunctionComponent<any>;
    showSessionTimeOutTimer?: boolean;
  };
  export type TUserFlowErrorBoundary = {
    children: JSX.Element | JSX.Element[];
    messageTitle?: string;
    messageDescription?: string;
  };
  export type TTenantSearchResponse = {
    military_info?: any;
    address: UpdateContactDetailsTypes.TAddress;
    tax_exempt?: any;
    id_proof?: any;
    unit_list?: any;
    total_balance?: number;
    total_deposit?: number;
    other_address?: any;
    phone?: UpdateContactDetailsTypes.TPhoneNumberField;
    dob?: string;
    sim_account?: any;
    last_contacted_date?: string;
    last_contacted_mode?: string;
    name: UpdateContactDetailsTypes.TNameField;
    has_missing_required_fields?: boolean;
    invoicing?: any;
    id: string;
    created_date?: string;
    facility?: any;
    email: UpdateContactDetailsTypes.TEmailField;
    status: string;
    ledger: TLedgerData[];
  };
  export type TLedgerData = {
    financials: PayRentTypes.TFinancials;
    balance: number;
    deposit: number;
    id: string;
    created_date: string;
    label: string;
    last_paid?: any;
    status: string;
    gate_access?: any;
  };
  export type TSmallDateFunction = (unitResponse: any) => undefined | string;
  export type TErrorLabel = {
    message:
      | string
      | FormikErrors<any>
      | string[]
      | FormikErrors<any>[]
      | undefined;
  };
  export type TExpiryNotificationTypes = {
    logOutHandler: any;
  };
}
